/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type InquiryResponseDtoPropertyTypesItem = typeof InquiryResponseDtoPropertyTypesItem[keyof typeof InquiryResponseDtoPropertyTypesItem];


export const InquiryResponseDtoPropertyTypesItem = {
  APARTMENT: 'APARTMENT',
  HOUSE: 'HOUSE',
  RECREATIONAL: 'RECREATIONAL',
  LAND: 'LAND',
  OTHER: 'OTHER',
} as const;
